<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table
			id="div-with-loading"
			ref="table"
			:multiple="teamListConfig.multiple"
			v-model="selected"
			pagination
			:max-items="itemsPerPage"
			search
			:data="listTeams"
		>
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<div class="flex flex-wrap-reverse items-center data-list-btn-container">
					<div
						v-if="teamCreatePermission && teamListConfig.btnAssign"
						@click="assignHandle"
						class="btn-add-new p-3 mb-3 mt-3 ml-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
					>
						<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
						<span class="ml-2 text-base text-primary">{{ "Asignar" }}</span>
					</div>
					<vs-button
						v-if="teamCreatePermission && teamListConfig.btnAdd"
						class="mr-2"
						color="primary"
						icon-pack="feather"
						icon="icon-plus"
						:title="$t('Teams.AddTeam')"
						@click.prevent="addNewData"
						>{{ $t("Teams.AddTeam") | capitalize }}
					</vs-button>
				</div>

				<!-- ITEMS PER PAGE -->
				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
					<div
						class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
					>
						<span class="mr-2"
							>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}
							-
							{{
								listTeams.length - currentPage * itemsPerPage > 0
									? currentPage * itemsPerPage
									: listTeams.length
							}}
							{{ $t("Of") }} {{ queriedItems }}</span
						>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>
					<vs-dropdown-menu>
						<vs-dropdown-item @click="itemsPerPage = 4">
							<span>4</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 15">
							<span>15</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 20">
							<span>20</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th v-show="teamListConfig.showColumns.name" sort-key="name">{{ $t("Teams.Table.Name") }}</vs-th>
				<vs-th v-show="teamListConfig.showColumns.description" sort-key="description">{{
					$t("Teams.Table.Description")
				}}</vs-th>
				<vs-th v-if="teamListConfig.showColumns.action">{{ $t("Teams.Table.Action") }}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td v-show="teamListConfig.showColumns.name">
							<p class="product-name font-medium truncate capitalize">
								{{ tr.name }}
							</p>
						</vs-td>

						<vs-td v-show="teamListConfig.showColumns.description">
							<p class="product-category normal-case">
								{{ tr.description }}
							</p>
						</vs-td>

						<vs-td class="whitespace-no-wrap" v-if="teamListConfig.showColumns.action">
							<feather-icon
								v-if="teamUpdatePermission"
								icon="EditIcon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								@click.stop="editData(tr)"
							/>
							<feather-icon
								v-if="teamDeletePermission"
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2"
								@click.stop="openConfirm(tr.id)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import moduleTeams from "@/store/teams/moduleTeams.js";

export default {
	name: "TeamsListView",
	props: {
		teamListConfig: {
			type: Object,
			default: () => {
				return {
					actionDropdown: true,
					btnAssign: false,
					btnAdd: true,
					columns: ["id", "name", "description", "action"],
					multiple: false,
					showColumns: {
						name: true,
						description: true,
						action: true,
					},
				};
			},
		},
		componentParent: {
			type: String,
			default: "TEAMS_LIST",
		},
	},
	data() {
		return {
			selected: [],
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
		};
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		listTeams() {
			let listTeams = this.$store.state.moduleTeams.teams;
			listTeams = listTeams.reverse();
			return listTeams;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listTeams.length;
		},
		teamUpdatePermission() {
			return this.$store.getters.checkPermission("TEAMS_U");
		},
		teamDeletePermission() {
			return this.$store.getters.checkPermission("TEAMS_D");
		},
		teamCreatePermission() {
			return this.$store.getters.checkPermission("TEAMS_C");
		},
	},
	methods: {
		addNewData() {
			this.$router.push("/dashboard/new-team");
		},
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Teams.Messages.TextDelete"),
				accept: this.acceptAlert,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		deleteData(id) {
			this.$store
				.dispatch("moduleTeams/removeItem", id)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Teams.Messages.TitleConfirmDelete"),
						text: this.$t("Teams.Messages.TextConfirmDelete"),
					});
				})
				.catch((err) => {
					console.error(err);
				});
		},
		editData(data) {
			this.$router.push("/dashboard/update-team/" + data.id);
		},
		assignHandle() {
			if (this.componentParent === "INDICATOR") {
				this.$store.commit("moduleTeams/ADD_ASSIGNED_TEAMS", [this.selected]);
			} else {
				this.$store.commit("moduleTeams/SET_ASSIGNED_TEAMS", this.selected);
			}
			this.$emit("closePopupEmit");
		},
	},
	created() {
		if (!moduleTeams.isRegistered) {
			this.$store.registerModule("moduleTeams", moduleTeams);
			moduleTeams.isRegistered = true;
		}
		this.$store.dispatch("moduleTeams/fetchDataListItems").then(() => {
			this.$vs.loading.close("#div-with-loading > .con-vs-loading");
		});
	},
	mounted() {
		this.isMounted = true;
		this.$vs.loading({
			container: "#div-with-loading",
			scale: 1,
			type: "sound",
		});
	},
};
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
